import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react/index";
import { observable, toJS, action } from "mobx";
import Modal from "../../Modal";
import Form, { FormActions, FormBody, SelectInput } from "../../Form";
import ReactDropzone from 'react-dropzone';

@inject('folderStore', 'stationStore', 'metaDataStore', 'metaDataTemplateStore')
@observer
class FolderStationImport extends React.Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = '/folder';
  title = 'Import Stations';

  @observable selectedFolderId = -1;
  @observable meta_data_template_id = null;
  @observable stations = [];
  @observable validFileUpload = false;
  @observable isSaving = false;
  stationColumns = [
    { key: 'identifier', label: 'Identifier', default: 'name' },
    { key: 'name', label: 'Name' },
    { key: 'latitude', label: 'Latitude', default: null },
    { key: 'longitude', label: 'Longitude', default: null },
    { key: 'elevation', label: 'Elevation', default: null },
    { key: 'description', label: 'Description', default: 'name' },
  ];

  @observable stationColumnMapping = [];
  @observable stationMetaData = [];

  componentWillMount() {
    const { metaDataStore, metaDataTemplateStore } = this.props;
    if (!metaDataStore.items.length) metaDataStore.fetchItems();
    if (!metaDataTemplateStore.items.length) metaDataTemplateStore.fetchItems();
  }


  @action onChangeFolder = e => this.selectedFolderId = +e.target.value;
  @action onChangeMetaDataTemplate = e => this.meta_data_template_id = +e.target.value;

  @action onChangeStationColumnMapping = (key, mappedTo) => {
    if (mappedTo.indexOf('metadata') > -1) {
      let metaData = this.stationMetaData.find(item => item.key === key);
      if (!metaData) {
        this.stationMetaData.push({
          key,
          mappedTo
        })
      } else metaData.mappedTo = mappedTo;
    } else this.stationColumnMapping.find(item => item.key === key).mappedTo = mappedTo;
  };

  onOpenAddFile = e => {
    e.preventDefault();
    this.refs.dropzone.open();
  };

  onDrop = (files) => {
    const { metaDataStore } = this.props;
    const { notify } = this.context;
    let reader = new FileReader();
    reader.readAsText(files[0]);
    reader.onabort = console.log;
    reader.onload = () => {
      try {
        let stations = [];
        if (files[0].type === 'application/json') {
          stations = JSON.parse(reader.result);
        } else if (files[0].type === 'text/csv' || files[0].type === 'application/vnd.ms-excel') {
          let csv = reader.result.split('\n'),
            labels = csv[0].split(',');
          csv.forEach((line, index) => {
            if (index > 0 && line !== '') {
              let station = {};
              labels.forEach((label, i) => {
                // let column = this.stationColumns.find(item => item.label.toLowerCase() === label.trim().toLowerCase());
                // if(!!column) Object.assign(station, {[column.key]: line.split(',')[i]})
                Object.assign(station, { [label.toLowerCase()]: (line.split(',')[i] || '').replace(/"/g, '').trim() })
              });
              stations.push(station)
            }
          });
        }

        this.stationColumnMapping = Object.keys(stations[0]).reduce((acc, key) => {
          let column = this.stationColumns.find(col => col.key === key);
          if (!!column) acc.push({ key, mappedTo: column.key })
          else {
            let metaData = metaDataStore.items.find(item => item.name === key);
            if (!!metaData) this.onChangeStationColumnMapping( key, `metadata-${metaData.id}`);
          }
          return acc;
        }, []);

        // this.stationColumnMapping = this.stationColumns.map(item => ({
        //   key: item.key,
        //   mappedTo: Object.keys(stations[0]).find(key => key === item.key)
        // }));

        if (!!stations && stations.length > 0) {
          let validStations = [];
          stations.forEach(station => {
            let count = 0, stationKeys = Object.keys(station);
            this.stationColumns.map(({ key }) => {
              if (stationKeys.indexOf(key) > -1) count++
            });
            if (count > 0) {
              validStations.push(station);
            }
          });
          if (validStations.length > 0) {
            this.stations = validStations;
            this.validFileUpload = true;
          } else notify.error({ message: 'Invalid Stations.' })
        }
      } catch (e) {
        console.log(e)
        notify.error({ message: 'Invalid File.' })
      }
    }
  };

  syncLoop = (array, promise, index = 0, responses = []) => (
    promise(array[index]).then((res) => {
      responses.push(res);
      if (index < array.length - 1) {
        return this.syncLoop(array, promise, index + 1, responses)
      } else {
        return Promise.resolve(responses)
      }
    }).catch(err => {
      this.syncLoop(array, promise, index + 1, responses);
      // notify.success({message: 'Stations imported'});
    })
  );

  handleSave = (e) => {
    e.preventDefault();
    const { stationStore } = this.props;
    const { notify, router } = this.context;

    let payload = this.stations.map(station => {
      let stationObj = { folder_id: this.selectedFolderId, meta_data_template_id: this.meta_data_template_id },
        meta_data = [];
      // this.stationColumnMapping.forEach(item => {
      //   if(item.mappedTo !== -1){
      //     Object.assign(stationObj, {[item.mappedTo]: station[item.key] || (typeof item.default === 'string' && item.default !== '' ? item[item.default] : item.default)})
      //   }
      // });

      this.stationColumns.forEach(column => {
        let mappedFrom = this.stationColumnMapping.find(item => item.mappedTo === column.key);
        let value = mappedFrom ? station[mappedFrom.key] : station[column.default] || column.default
        if (value !== '') Object.assign(stationObj, { [column.key]: value })
      });

      this.stationMetaData.forEach(metaDataMapper => {
        let value = station[metaDataMapper.key];
        if (!!value && value !== '') meta_data.push({
          meta_data_id: +metaDataMapper.mappedTo.split('-')[1],
          value
        })
      });

      return Object.assign(stationObj, { meta_data });
    });
    // console.log(payload)
    
    this.isSaving = true;
    this.syncLoop(payload, (item) => stationStore.createItem(item))
      .then(() => {
        this.isSaving = false;
        notify.success({ message: 'Success' });
        router.push(this.slug);
      })
      .catch(err => {
        this.isSaving = false;
        notify.error(err);
      });;
  };

  _renderImportTable = (stations, stationColumns, metaData) => {
    return (<table className='DataTable' style={{ maxWidth: '80vw' }}>
      <thead>
        <tr>{Object.keys(stations[0]).map((item, i) => <th key={`thead-${item}-${i}`}>{item}</th>)}</tr>
        <tr>{Object.keys(stations[0]).map((key, i) => {
          let mappedColumn = this.stationColumnMapping.find(cm => cm.key === key),
            mappedMetaData = this.stationMetaData.find(sm => sm.key === key);
          return <th key={`thead-${key}-${i}-mapper`}>
            <select value={mappedColumn ? mappedColumn.mappedTo : mappedMetaData ? mappedMetaData.mappedTo : -1}
              onChange={(e) => this.onChangeStationColumnMapping(key, e.target.value)}>
              <option value={-1}>--</option>
              {stationColumns.map(item => <option key={`${key}-mapper-option-${item.key}`}
                value={item.key}>{item.label}</option>)}
              {metaData.map(item => <option key={`${key}-mapper-option-${item.id}-metadata`}
                value={`metadata-${item.id}`}>{item.name}</option>)}
            </select>
          </th>
        })}</tr>
      </thead>
      <tbody>{stations.map((station, i) => <tr key={`tbody-station-${i}`}>{Object.keys(station).map((key, j) => <td
        key={`tbody-station-${key}-${j}`}>{station[key]}</td>)}</tr>)}</tbody>
    </table>);
  };

  render() {
    const { folderStore, metaDataStore, metaDataTemplateStore } = this.props;
    return (
      <Modal slug={this.slug} title={this.title} isSaving={this.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <SelectInput
              label={'Folder'}
              value={this.selectedFolderId}
              fields={{ label: 'name', value: 'id' }}
              options={toJS(folderStore.items)}
              onChange={this.onChangeFolder}
            />
            <SelectInput
              label={'Meta Data Template'}
              value={this.meta_data_template_id}
              fields={{ label: 'name', value: 'id' }}
              options={toJS(metaDataTemplateStore.items)}
              onChange={this.onChangeMetaDataTemplate}
            />
          </FormBody>
          {!this.stations.length ? <button onClick={this.onOpenAddFile}>Upload Exported
            JSON</button> : this._renderImportTable(this.stations, this.stationColumns, metaDataStore.items)}
          <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }}>
            <div>Try dropping a file here, or click to select a file to upload.</div>
          </ReactDropzone>
          {this.validFileUpload && <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>}
        </Form>
      </Modal>
    );
  }
}

export default FolderStationImport;


// WEBPACK FOOTER //
// ./src/components/Folder/StationImport/FolderStationImport.js